import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

//Import screens
import DepositScreen from '../pages/deposito'
import WithdrawScreen from '../pages/retirada'
import RedirectForMonnet from '../pages/redirect_monnet'
import Error404 from '../pages/error404'
import { ConsultaOrdemTermos } from '../pages/consulta_termo'
import GetParameterURL from '../components/GetParameterURL'
import { useHistory, useLocation } from 'react-router-dom'

const PrivateRoute = (props) => {
    sessionStorage.clear();
    let history = useHistory();
    let location = useLocation();
    let country = GetParameterURL("country", history, location);
    let broker = GetParameterURL("broker", history, location);
    let order_no = GetParameterURL("order_no", history, location);  
    if(country.length === 0 || broker.length === 0 || order_no.length === 0){
        return (
            <>
                {history.push("/404", {country: country, broker: broker, order_no: order_no, from: location.pathname})}
            </>
        )
    }else{
        sessionStorage.setItem("country", country);
        sessionStorage.setItem("broker", broker);
        sessionStorage.setItem("order_no", order_no);      
        return (
            <Redirect to={props.to} />
        )
    }
};

const PrivateRouteTestes = ({ component: Component, ...rest }) => {
    sessionStorage.clear();
    let history = useHistory();
    let location = useLocation();
    let country = GetParameterURL("country", history, location);
    let broker = GetParameterURL("broker", history, location);
    let order_no = GetParameterURL("order_no", history, location);

    if(country.length === 0 || broker.length === 0 || order_no.length === 0){
        return (
            <>
                {history.push("/404", {country: country, broker: broker, order_no: order_no, from: location.pathname})}
            </>
        )
    }else{
        sessionStorage.setItem("country", country);
        sessionStorage.setItem("broker", broker);
        sessionStorage.setItem("order_no", order_no);
        return (
            <Route
                {...rest}
                render={props => (
                    <Component {...props} />
                )}
            />
        )
    }
};

const Routes = () => {
    return (
        <BrowserRouter>
            <Switch>
                <PrivateRoute path="/deposit" to="/deposit_order" />
                <PrivateRouteTestes path="/testedeposit" component={DepositScreen} />
                <PrivateRoute path="/withdraw" to="/withdraw_order" />
                <Route exact path="/deposit_order" component={DepositScreen} />
                <Route exact path="/withdraw_order" component={WithdrawScreen} />
                <Route exact path="/consulta-ordem" component={ConsultaOrdemTermos} />
                <Route exact path="/redirect_url" component={RedirectForMonnet} />
                <Route path="/404" component={Error404} />
                {/*<Redirect to="/deposit?order_no=D1000500&broker=ipromarkets&country=br" />*/}
                <Redirect to="/404" />
            </Switch>
        </BrowserRouter>
    )
}

export default Routes;